import React, { useState, lazy, Suspense } from "react";
import Launcher from "./components/Launcher";

// Lazy load each app for performance
const ResonanceStudio = lazy(() => import("./apps/ResonanceStudio"));
const ResonanceCanvas = lazy(() => import("./apps/ResonanceCanvas"));
const ResonanceIllustrator = lazy(() => import("./apps/ResonanceIllustrator"));
const ResonancePublisher = lazy(() => import("./apps/ResonancePublisher"));
const ResonanceDarkroom = lazy(() => import("./apps/ResonanceDarkroom"));
const ResonanceProduction = lazy(() => import("./apps/ResonanceProduction"));
const SettingsPage = lazy(() => import("./settings/SettingsPage.jsx"));

const Loading = () => (
  <div style={{
    width: "100vw", height: "100vh", background: "#0A0A0A",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontFamily: '"Cormorant Garamond", serif', color: "#D4AF37",
    fontSize: "24px", letterSpacing: "4px",
  }}>
    RESONANCE
  </div>
);

const APP_MAP = {
  studio: ResonanceStudio,
  canvas: ResonanceCanvas,
  illustrator: ResonanceIllustrator,
  publisher: ResonancePublisher,
  darkroom: ResonanceDarkroom,
  production: ResonanceProduction,
  settings: SettingsPage, // ?app=settings, or the link under the launcher grid
};

export default function App() {
  // Deep link: ?app=production opens an app directly (also used by the acceptance test)
  const [activeApp, setActiveApp] = useState(() => {
    const q = new URLSearchParams(window.location.search).get("app");
    return q && APP_MAP[q] ? q : null;
  });

  if (!activeApp) {
    return <Launcher onLaunch={setActiveApp} />;
  }

  const AppComponent = APP_MAP[activeApp];

  return (
    <div style={{ position: "relative", width: "100vw", height: "100vh" }}>
      {/* Back to launcher button */}
      <button
        onClick={() => setActiveApp(null)}
        title="Back to Suite"
        style={{
          position: "fixed", top: "4px", left: "4px", zIndex: 9999,
          background: "#0A0A0A", color: "#D4AF37", border: "1px solid #1E1E1E",
          borderRadius: "3px", padding: "2px 8px", fontSize: "9px",
          cursor: "pointer", fontFamily: '"Source Sans 3", sans-serif',
          opacity: 0.6, transition: "opacity 0.2s",
        }}
        onMouseEnter={e => e.target.style.opacity = 1}
        onMouseLeave={e => e.target.style.opacity = 0.6}
      >
        ◀ Suite
      </button>
      <Suspense fallback={<Loading />}>
        <AppComponent />
      </Suspense>
    </div>
  );
}
